import React, {Component} from 'react';
import SecondServer from '../database/SecondServer';
import {errorResponse} from '../database/apiMethods';
import {urlSiteDevices} from '../database/apiUrls';
import { siteAccessCode } from '../database/apiv2SiteAccessor';
import FilterPanel from './Controls/FilterPanel'
import DatePanelChildren from './Controls/DatePanelChildren'
import { TitleRow, RowOfChildren, GridText, formatTable, clickToTableTarget, newSortIndicators, 
        clickToNamedClass, flipIndicator, flipSort} from "./RenderHelpers";
import MultiLineChart from './Troubleshooting/MultiLineChart'
import SingleLineChart from './Troubleshooting/SingleLineChart'
import BatteryHistogram from '../Chart/BatteryHistogram';
import LinkQualityHistogram from '../Chart/LinkQualityHistogram';
import NoResults from '../Alert/NoResults'
import EZNotify from '../Alert/SimplerNotify'
import { csvDownload } from '../csv/csvExport';
import DeviceHealthData from '../Overview/DeviceHealthData';
import CsvButton3 from './Controls/CsvButton3'
import ChangeDevice from './Controls/ChangeDevice'
import { dateSort} from './helperfunctions'
import { deDupe } from '../Chart/ChartData';
import Switch from './Controls/Switch'
import { isTransceiverRadio, isRepeaterRadio, isDCAPRadio, fetchMdtConfig } from './Model/DeviceType';
import TStatus from './Troubleshooting/TStatus';
import GridAction from './Controls/GridAction'
import ReportingFilter from './Controls/ReportingFilter'
import AdvancingFilter from './Controls/AdvancingFilter'
import RepeaterFilter from './Controls/RepeaterFilter'
import {cleanDateTime, sanitizeDateTime} from "../timeFunctions/timeFns"
import { nestedProp } from '../Utils/object';
import { fetchNetworkStatus } from './DataHelpers';
import ChartModal from '../Chart/ChartModal'
import { renderLoader } from "../Loading/loading";
import LinkChart from '../Chart/LinkChart';
import { linkPartners } from '../Utils/linkPartners';
import { getIcons, nameToIcon, deviceIcon } from "./Controls/DeviceIcons";
import { filterRPMT } from '../Report/Model/DeviceType';
import {shortTimeAgo} from '../timeFunctions/timeFns'
import {TryAgain} from '../Alert/CommonNotices'

import './report.css'
import '../Chart/LineGraph.css'

export default class Reports extends Component {
  constructor(props) {
    super(props);
    this.coreProp = ["device_id", "building", "apt",  "LatestLinkStatusData.LinkQuality", "BattVolt",] 
    this.contact = "LatestLinkStatusData.RXTime"
    this.apiProp = this.coreProp.concat([this.contact, "LatestLinkStatusData.DestAdrs"])
    this.displayProp = this.coreProp.concat(['timeAgo', "LatestLinkStatusData.DestAdrs"])
    this.sortProp = this.coreProp.concat(['contact', "LatestLinkStatusData.DestAdrs"])
    this.config = {
      sortOrder: ["", ...this.sortProp, "actions"],
      displayName : ["", "Radio Id",   "Building", "Apt", "Link Quality", "Battery", "Last Contact", "Link Partner", "Actions"],
      sortable :    [false, true,        true,      true,    true,          true,     true,            true,          false],    
      toCSV :       [false, true,        true,      true,    true,          true,     true,            true],
    }

    this.state = {
      report:  null,
      apiData: null,
      errorMsg: null,
      modalShow: 0,
      endrange: new Date(),
      startrange: new Date(Date.now() - 24*3600 * 1000),
      chartProps: null,
      networkData: null,
      batteryFormat: this.props?.batteryFormat() ?? 0,
      isLoading: true,
      loader: renderLoader(),
      mdts: undefined,
      rptrs: undefined,
      health: null,
      colSort: newSortIndicators(this.config.sortOrder.length),
      lastSort: null,
      interval: 'Last day',
      intVal: 0,
      showLQ: true,
      showBatt: true,
      apiIcons: undefined,
      reportingFilter: false,
      advancingFilter: false,
      repeaterFilter: false,
    };
    this.defaultChartCol = ['BattVolt'];
    this.apiConversion = {'FarEndRssi': 'FarEndRssi', 'LQ': 'LinkQuality', 'BattVolt' : 'BattVolt'};
    this.chartTitle= {'FarEndRssi': 'Signal', 'LQ': 'Link Quality', 'BattVolt' : 'Battery'};
    this.healthData = null;
    this.device = "device_id"
    this.ss = undefined

    this.graph = this.graph.bind(this);
    this.readings = this.readings.bind(this)
    this.links = this.links.bind(this)
    this.toggleChart = this.toggleChart.bind(this);
    this.setFilters = this.setFilters.bind(this);
    this.sort = this.sort.bind(this)
    this.batteryFilter = this.batteryFilter.bind(this)
    this.mdtLinkQualityFilter = this.mdtLinkQualityFilter.bind(this)
    this.rptrLQFilter = this.rptrLQFilter.bind(this)
    this.lqSlider = this.lqSlider.bind(this)
    this.battSlider = this.battSlider.bind(this)
    this.reportingFilter = this.reportingFilter.bind(this)
    this.advancingFilter = this.advancingFilter.bind(this)
  }

  async componentDidMount() {
    this.setState ({isLoading:true})
    const site = this.props.getActiveSite();
    const url = urlSiteDevices(siteAccessCode(site))
    this.ss = new SecondServer(this.props);
    const prom = getIcons ({...this.props, ss: this.ss, ac: siteAccessCode(site)})
    prom.then((result) => {
      this.setState ({apiIcons: result?.data?.icons})
    }) 
    const jsonResponse = await this.ss.apiData (url);
    if (errorResponse(jsonResponse)) {
      this.setState ( {errorMsg: this.ss.getErrorMsg(), isLoading:false } );
    }
    else {
      if (jsonResponse?.data?.data?.targetDevices) {
        const displayResponse = this.initTable(jsonResponse)
        const mdts = this.filterRepeaters(displayResponse, false)
        const rpters = this.filterRepeaters(displayResponse, true)
        this.setState( {report: displayResponse, apiData: jsonResponse, isLoading:false,
              mdts: mdts, rptrs: rpters} );
        this.healthData = new DeviceHealthData(this.props);
        const hlth = await this.healthData.getHealthofThese(this.state.startrange, this.state.endrange, displayResponse, "device_id")
        const moreHlth = await this.healthData.getHealthFromThese(this.state.startrange, this.state.endrange, displayResponse)
        const newState = hlth
        newState.advData = moreHlth.advData
        this.setState({health: newState})
        if (this.props?.filter?.dev === 'nonadv') {
          this.advancingFilter()
        }
        else if (this.props?.filter?.dev === 'mdt') { 
          this.applyFilter(mdts?.filter(item=>isNaN(nestedProp(item, 'LatestLinkStatusData.LinkQuality'))))
        }
        else if (this.props?.filter?.dev === 'rptr') {
          this.repeaterFilter()
        }
      }
      else { // show no data here
        this.setState ({isLoading:false})
      }
    }
    this.loadChartData();
  }
 
  async componentDidUpdate(prevProps, prevState) {
    if (this.props?.update && prevProps.update < this.props.update) {
      this.resetFilters()
      this.componentDidMount()
    }
    if ((prevState.startrange.getTime() !== this.state.startrange.getTime() ||
      prevState.endrange.getTime() !== this.state.endrange.getTime()) && this.healthData) {
        const promise = await this.healthData.getHealth(this.state.startrange, this.state.endrange);
        this.setState ({health: promise})
        await this.loadChartData();
        if (this.state.modalShow > 0) {
          this.recomputeChart()
        }
    }
    if (this.state.batteryFormat !== this.props.batteryFormat()) {
      this.setState ({batteryFormat: this.props.batteryFormat()})
    }

    if (prevProps.radioStyle !== this.props.radioStyle) {
      const display = this.initTable(this.state.apiData)
      this.setState( {report: display} );  
    }
  }
  componentWillUnmount() {
    this.ss.cancel()
  }
  initTable(apiResp) {
    let displayResponse = formatTable (apiResp.data.data.targetDevices, "device_id", this.props.radioStyle)
    displayResponse = displayResponse.filter (item => !isDCAPRadio(item, 'device_id'))
    this.formatBattVolt(displayResponse)
    displayResponse = this.fmtContact(displayResponse, this.contact)
    return displayResponse;
  }

  resetFilters() {    //refresh clicked
    this.setState({reportingFilter: false, advancingFilter: false,
      repeaterFilter: false, })
  } 
  formatBattVolt(arrData) {
    if (Array.isArray(arrData)) {
      arrData.forEach(row => {
        row.BattVolt = (0.001 * parseFloat(nestedProp(row, "LatestLinkStatusData.BattVolt"))).toFixed(2) 
        row.BattVolt = row.BattVolt > 0.09 ? row.BattVolt : undefined
      })
    }
  }

  toggleChart(newState=0) {
    this.setState ( {modalShow: newState});
  }

  graph (evt) {
    const btn= clickToNamedClass(evt, "actButton")
    const index = btn.getAttribute('index')
    // console.log (this.state.report[index])
    const deviceId = this.state.report[index]["device_id"]
    const location = "Apt " + this.state.report[index].apt
    this.setChartData (deviceId, location)
    this.toggleChart(1)
  }
  async readings (evt) {
    const btn= clickToNamedClass(evt, "actButton")
    const index = btn.getAttribute('index')
    const deviceId = this.state.report[index]["device_id"]
    const site = this.props.getActiveSite()
    if (site?.site_details?.devices) {
      const devcfg = site.site_details.devices.find(d => d.device_id.toUpperCase() === deviceId)
      this.setState({deviceId: deviceId, deviceConfig: devcfg})
    }
    else {
      const ss = new SecondServer(this.props)
      const cfg = await fetchMdtConfig (ss, siteAccessCode(site), deviceId)
      this.setState({deviceId: deviceId, deviceConfig: cfg?.devices[0]})
    }
    const location = "Apt " + this.state.report[index].apt
    this.setChartData (deviceId, location)
    this.toggleChart(2)
  }
  links (evt) {
    const btn= clickToNamedClass(evt, "actButton")
    const index = btn.getAttribute('index')
    const deviceId = this.state.report[index]["device_id"]
    const location = "Link Partners for Apt " + this.state.report[index].apt
    this.setChartData (deviceId, location)
    this.toggleChart(3)
  }
  sort(e) {
    const targ = clickToTableTarget(e);
    if (this.config?.sortable[targ.cellIndex] === false) 
      return;
    if ("id" in targ) {
      const column = targ.id.trim();
      const arrSort = flipIndicator (targ, this.state.colSort, this.state.lastSort)
      flipSort(this.state.report, column, this.state.lastSort)
      this.setState ({ lastSort: column, colSort: arrSort});
    }
  }

  filter = (search) => {
    const arrData = this.initTable(this.state.apiData).slice(0);
    let arrFilter = arrData
    if (search.length > 0) {
      const usearch = search.toUpperCase();
      arrFilter = arrData.filter (item => {
        return Object.values(item).join('').toUpperCase().includes(usearch)
      });
    }
    const display = formatTable (arrFilter, "device_id", this.props.radioStyle);
    this.setState({report: display});
  }
  setFilters(which, panelState) {
    if (which === 'filter') {
      const search = panelState ?? "";
      this.filter(search);
    }
    if (which === 'date') {
      const sd = panelState?.startTime ?? this.state.startrange;
      const ed = panelState?.endTime ?? this.state.endrange;
      const name = panelState?.desc ?? ''
      this.setState ({startrange: sd, endrange: ed, interval: name, intVal: panelState.dropDown});
    }
  }

  batteryFilter (bins, index) {
    const filt = this.histoFilter ('BattVolt', bins, index)
    this.applyFilter(filt, 'mdt')
  }

  mdtLinkQualityFilter (bins, index) {
    const filt = this.histoFilter ('LatestLinkStatusData.LinkQuality', bins, index, this.state.mdts)
    this.applyFilter(filt)
  }
  rptrLQFilter (bins, index) {
    const filt = this.histoFilter('LatestLinkStatusData.LinkQuality', bins, index, this.state.rptrs)
    this.applyFilter(filt)
  }
  histoFilter (prop, bins, index, toFilter=undefined) {
    let arrFilter = toFilter ?? this.initTable(this.state.apiData).slice(0)
    if (index === -1) {   //reset
      arrFilter = this.initTable(this.state.apiData).slice(0)
    }
    else if (index > -1 && isNaN (bins[index])) {
      arrFilter = arrFilter.filter(item=> isNaN(nestedProp(item, prop)))
    }
    else if (index === 0 || (index === 1 && isNaN(bins[0]))) {
      arrFilter = arrFilter.filter(item=> nestedProp(item, prop) < bins[index+1])
    }
    else if (index === bins.length-1) {
      arrFilter = arrFilter.filter (item => nestedProp(item, prop) >= bins[index]);
    }
    else if (index > 0) {
      arrFilter = arrFilter.filter (item => 
        nestedProp(item, prop) >= bins[index] && nestedProp(item, prop) < bins[index+1]
      );
    }
    return arrFilter
  }
  applyFilter (data, type='') {
    const display = formatTable (data, this.device, this.props.radioStyle);
    const mdts = data.filter (item => !isRepeaterRadio(item, 'device_id'))
    const rpters = data.filter (item =>isRepeaterRadio(item, 'device_id'))
    if (type === 'mdt')
      this.setState({report:mdts, mdts:mdts, rptrs:rpters})
    else
      this.setState({report: display, mdts: mdts, rptrs: rpters});  
  }
  async loadChartData () {
    const siteId = siteAccessCode(this.props.getActiveSite());
    let ss = new SecondServer(this.props)
    const chartData = await fetchNetworkStatus(siteId, this.state.startrange, this.state.endrange, ss);
    //console.log (chartData)
    if (chartData?.jsonResponse?.data?.data?.raw_data) {
      this.setState ({networkData: chartData.jsonResponse.data.data.raw_data})
    }
  }

  setChartData (radioId, location) {
    if (this.state.networkData) {
      const xform = this.apiConversion[this.defaultChartCol]
      const devicedata = this.state.networkData.filter(item => item.DeviceId.toUpperCase() === radioId && item[xform])
      const byDate = dateSort(devicedata, "ReadTime", 0)
      const chartdata = this.state.showBatt ? byDate.map (item=>item?.BattVolt) :[]
      const chartdata2 = this.state.showLQ ? byDate.map (item=>item?.LinkQuality) : []
      const labeldata = byDate.map(item => new Date(item.ReadTime+' GMT'))
      const chartable = deDupe(labeldata, chartdata)
      const chartdata3 = linkPartners(this.state.networkData, radioId)
      this.setState ( {chartProps: 
        {title: location, radioId: radioId, sensor: '', units: '', 
          sensorType: "", data: chartable.series1, label: chartable.xaxis, apiParams: 'NetworkData',
          series2: chartdata2, series3: chartdata3,  plotValue: this.defaultChartCol, showUsage: true,
          interval: this.state.intVal 
        }
      });  
    }
  }

  chartControls () {
    return (
      <DatePanelChildren {...this.props} propagateState={this.setFilters} 
          dropDown={this.state.intVal} startTime={this.state.startrange} endTime={this.state.endrange}>
        <ChangeDevice changeDevice={this.state.modalShow && this.toggleChart} />
      </DatePanelChildren>
    )
  }
  battSlider() {
    this.setState({showBatt: !this.state.showBatt}, this.recomputeChart)
  }
  lqSlider() {
    this.setState ({showLQ: !this.state.showLQ}, this.recomputeChart)
  }
  recomputeChart () {
    this.setChartData(this.state.chartProps.radioId, this.state.chartProps.title)
  }
  showChart() {
    if (this.state.chartProps?.radioId.startsWith('E')){
      return (
        <div className='chart-title'>{this.state.chartProps?.title}, Repeater {this.state.chartProps?.radioId}
          <SingleLineChart show={this.state.modalShow} hide={()=>this.toggleChart(0)} chartProps={this.state.chartProps}
          startrange={this.state.startrange} endrange={this.state.endrange} {...this.props}/>
        </div>
      );
    }
    else{
      return (
        <>
          <div className='chart-title'>{this.state.chartProps?.title}, MDT {this.state.chartProps?.radioId}
            <span className="chart-slider batt-color ">
              <Switch value={this.state.showBatt} onClick={this.battSlider}/> Battery</span>
            <span className="chart-slider lq-color">
              <Switch value={this.state.showLQ} onClick={this.lqSlider}/> Link Quality</span>
          </div>
          <MultiLineChart show={this.state.modalShow} hide={()=>this.toggleChart(0)} chartProps={this.state.chartProps}
          startrange={this.state.startrange} endrange={this.state.endrange} {...this.props}/>
        </>
      );
    }
  }
  showLinks() {
    const deviceType = this.state?.chartProps?.radioId.toUpperCase().startsWith('E') ? "Repeater" : "MDT"
    return (
      <div className='chart-title'>{this.state.chartProps?.title}, {deviceType} {this.state.chartProps?.radioId}
        <LinkChart show={this.state.modalShow} hide={()=>this.toggleChart(0)} chartProps={this.state.chartProps}
        startrange={this.state.startrange} endrange={this.state.endrange} {...this.props}/>
      </div>
    );
  }
  sensorTypes () {
    const arrWanted = this.state.report.filter(item=>item.device_id === this.state.deviceId)
    const mdtWanted = Array.isArray(arrWanted) ? arrWanted[0] : undefined
    return [mdtWanted?.LatestData?.SensorType1, mdtWanted?.LatestData?.SensorType2]
  }
  showReadings() {
    const st = this.state
    const sensors = this.sensorTypes()
    const deviceMeta = {units1: st.deviceConfig?.sensors[0]?.units ?? '', 
      units2: st.deviceConfig?.sensors[1]?.units ?? '',
      Type: st.deviceConfig?.type, 
      SensorType1: st.deviceConfig.sensors[0]?.display_type ?? '',
      SensorType2: st.deviceConfig.sensors[1]?.display_type ?? ''}
    const chartProps = {radioId: st.deviceId, apiParams: 'SensorData',
      sensorType: sensors[0], sensorType2: sensors[1], deviceMeta: {...deviceMeta}
     }
    return (
      <ChartModal show={st.modalShow} hide={()=>this.toggleChart(0)} deviceId={st.deviceId}
        chartProps={chartProps} {...this.props} deviceConfig={st.deviceConfig}
        startrange={st.startrange} endrange={st.endrange} singleBlock={false} />
    )
  }
  fmtContact (apiData, contactProp) {
    const step1 = apiData?.map(item => ({...item,
      contact: cleanDateTime(nestedProp(item, contactProp), {zone: 'UTC'})
    }))
    const step2 = step1?.map (item => ({...item, 
        timeAgo: shortTimeAgo(item.contact)}))
    return step2
  }
  toggleReporting = () => {
    const active = !this.state.reportingFilter
    const table = this.reportingFilter(active, this.state.report)
    this.setState({reportingFilter: active, report: table})
  }
  reportingFilter (active, from) {
    const pass1 = this.filterCurrentRepeaters(from)
    return ( active ? 
      this.filterOut(pass1, this.state.health.connData) :
      this.redoFilterButtons('reportingFilter')
    )
  }
  filterCurrentRepeaters (from) {
    if (!Array.isArray(from))
      return []
    const sus = from.filter (item => !isRepeaterRadio(item, "device_id") ||
      sanitizeDateTime (item?.LatestLinkStatusData?.RXTime, {zone: 'UTC'}).getTime() < 
      this.state.startrange.getTime()
    )
    return sus
  }
  advancingFilter() {
    const active = !this.state.advancingFilter
    const display = active ? 
      this.filterNonAdv(this.state.report, this.state.health.advData) :
      this.redoFilterButtons('advancingFilter')
    this.setState({advancingFilter: active, report:display})
  }
  filterOut (from, toRemove) {
    const ucRemove = toRemove.map(item=>item.toUpperCase())
    return from.filter(item=>!ucRemove.some(r=>item[this.device] === r))
  }
  filterNonAdv (from, nonAdv) {
    const mdts = this.filterRepeaters(from, false)
    const ucNon = nonAdv?.map(item=>item?.device_id?.toUpperCase())
    return mdts.filter(item=>ucNon.some(r=>item[this.device] === r))
  }
  repeaterFilter = () => {
    const active = !this.state.repeaterFilter
    const display = active ? this.filterRepeaters(this.state.report, true) :
      this.redoFilterButtons ('repeaterFilter')
    this.setState({repeaterFilter: active, report:display})
  }
  filterRepeaters (from, onOff) {
    return from.filter(item => onOff === isTransceiverRadio(item, "device_id"))
  }
  redoFilterButtons(omit) {
    let display = this.initTable(this.state.apiData)
    if (this.state.reportingFilter && omit !== 'reportingFilter')
      display = this.reportingFilter(this.state.reportingFilter, display)
    if (this.state.advancingFilter && omit !== 'advancingFilter')
      display = this.filterNonAdv(display, this.state.health.advData)
    if (this.state.repeaterFilter && omit !== 'repeaterFilter')
      display = this.filterRepeaters(display, this.state.repeaterFilter)
    return display
  }
  filterOnlyCurrentRepeaters (from) {
    if (!Array.isArray(from))
      return []
    const allRpmt = filterRPMT(from)
    let connRpmt = allRpmt
    if (this.state?.apiIcons) {
      connRpmt = allRpmt.map (r => this.state?.apiIcons?.some(
      i=>i?.device_id === r?.device_id && i?.icon === 'GRN_CHK'))
    }
    return from.filter(item => sanitizeDateTime (item?.LatestLinkStatusData?.RXTime, {zone: 'UTC'}).getTime() >= 
      this.state.startrange.getTime()).concat(connRpmt.filter(i => i === true))
  }
  tableControls (csvFunction, tableId) {
    return (
      <FilterPanel {...this.props} propagateState={this.setFilters} dropDown={this.state.intVal}>
        <ReportingFilter {...this.props} onClick={this.toggleReporting} active={this.state.reportingFilter} />
        <AdvancingFilter {...this.props} onClick={this.advancingFilter} active={this.state.advancingFilter}/>
        <RepeaterFilter {...this.props} onClick={this.repeaterFilter} active={this.state.repeaterFilter}/>
        <span className="right-side">
          <CsvButton3 csvClick={csvFunction} csvTable={tableId} toCSV={this.config.toCSV}/>
        </span>
      </FilterPanel>
      )
  }

  getIcon(device) {
    if (this.state.apiIcons) {
      const icon = deviceIcon(this.state.apiIcons, device?.device_id)
      return nameToIcon(icon?.icon)  
    }
    return null
  }

  showTable(tableId) {
    if (this.state.isLoading)
      return this.state.loader
    if (this.state.errorMsg) 
      return (<EZNotify message={this.state.errorMsg} styleName="warning"/>);
    const devices = this.state?.report 
    if (Array.isArray(devices) && devices.length > 0) {
      const colSeq = this.config.sortOrder;
      const colNames = this.config.displayName;
      const sortable = this.config.sortable
      return (
        <table className="csv-table" id={tableId}>
          <tbody>
          <TitleRow index={0} data={devices[0]} colName={colNames} colSeq={colSeq} 
            sortable={sortable} colSort={this.state.colSort} graph={this.sort}/>
          {devices.map((dev, index) => 
            <RowOfChildren id={index} key={index}>
              {this.getIcon(dev)}
              {this.displayProp.map(p => 
                (<GridText value={nestedProp(dev, p)} key={index}/>))}
              <GridAction id='action' index={index} wrap="act-column" key="act"
                altChart={this.graph} onChart={this.readings} linkChart={this.links} />
            </RowOfChildren>
          )}
          </tbody>
        </table>
      );
    }
    else return (<NoResults />);
  }

  renderContent () {
    switch (this.state.modalShow) {
      case 0:
      default:
        return ( <>
          {this.tableControls(csvDownload, 'dispTable')}
          {this.showTable('dispTable')}
          </>
        )
      case 1:
        return (<>
          {this.chartControls()}
          {this.showChart()} 
          </>
        )
      case 2:
       return (<>
          {this.chartControls()}
          {this.showReadings()} 
          </>
        )
      case 3:
        return (<>
          {this.chartControls()}
          {this.showLinks()}
          </>
        )  
      }
  }
  render() {
    try {
      const mdt = this.state?.mdts?.length ?? 0 
      //const nonAdvs = this.filterNonAdv (this.state?.mdts??[], this.state?.health?.advData??[])
      //const nonConn = Math.max(mdt - (this.state.health?.connected??0), 0)
      const advs = this.state.health?.advancing ?? 0
      const stat1 = {label: "MDTs reporting in the "+this.state.interval, 
                    numerator: Math.min(this.state.health?.connected??0, mdt), denom: mdt}
      const stat2 = {label: "MDTs advancing in the "+this.state.interval, 
                    numerator: advs??0, denom: mdt}
      const rptr = this.filterOnlyCurrentRepeaters(this.state.rptrs)
      const stat3 = {label: "Repeaters reporting in the "+this.state.interval, 
                    numerator: rptr.length, denom: this.state.rptrs?.length ?? 0}
      return (
        <div className="container-fluid">
          <div className="histogram-container">
            <div className="histogram-row">
            <BatteryHistogram data={this.state.mdts} histoFilter={this.batteryFilter}/>
            <LinkQualityHistogram title="MDTs - " data={this.state.mdts} histoFilter={this.mdtLinkQualityFilter}/>
            <LinkQualityHistogram title="Repeaters - " data={this.state.rptrs} histoFilter={this.rptrLQFilter}/>
            </div>
          </div>
          <div className="ts-status-container">
            <div className="ts-status-row">
              <div className="histogram-single"><TStatus {...stat1} /></div>
              <div className="histogram-single"><TStatus {...stat2} /></div>
              <div className="histogram-single"><TStatus {...stat3} /></div>
            </div>
          </div>
          {this.renderContent()}
        </div>
      )
            
    }
    catch (err) {
      console.log (err)
      return (<TryAgain details={"Troubleshoot.render: "+err.toString()} />)
    }
  }
}
/*
        {this.state.modalShow ? this.chartControls() : this.tableControls(csvFunction, tableId)}
        {this.state.modalShow ? this.showChart() : this.showTable(tableId)}
*/